import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import "../../assets/css/Loader.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

function ProductItem() {
  const navigate = useNavigate();
  const toast = useToast();

  // ── English → Tamil translation via MyMemory API ──────────────────────
  const [isTranslating, setIsTranslating] = useState(false);

  const translateToTamil = async (englishText) => {
    if (!englishText || englishText.trim().length < 2) return "";
    try {
      setIsTranslating(true);
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(
        `https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`
      );
      const data = await res.json();
      const translated = data?.responseData?.translatedText || "";
      if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
        return translated;
      }
      return "";
    } catch {
      return "";
    } finally {
      setIsTranslating(false);
    }
  };
  // ────────────────────────────────────────────────────────────────────────
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);

  // CRUD operation data states
  const [responseData, setResponseData] = useState([]);
  const [addData, setAddData] = useState({
    item_name: "",
    item_name_tamil: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateData, setUpdateData] = useState({
    item_name: "",
    item_name_tamil: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateid, setUpdateId] = useState("");
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, []);

  // Filter data based on search term
  const filteredData = responseData.filter((item) =>
    (item.item_name || item.type || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate pagination values
  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  // Modal handlers
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const closeUpdateModal = () => setUpdateModal(false);
  const handleOpenModal = (id, type) => {
    setdeleteid(id);
    setdeletename(type);
    setDeleteShowModals(true);
  };
  const handleCloseModal = () => setDeleteShowModals(false);

  // Fetch product types from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
      setResponseData(response.data?.data || []);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
      setResponseData([]);
      setLoading(false);
    }
  };

  // Add new product item
  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        item_name: addData.item_name,
        item_name_tamil: addData.item_name_tamil,
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };
      await axios.post(`${ApiUrl}/Api/product_type.php`, formData);
      setShowModal(false);
      toast.success("Added Successfully!", 3000, "topRight");
      setAddData({
        item_name: "",
        item_name_tamil: "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      });
      fetchData();
    } catch (error) {
      console.error("Error adding data:", error.message);
      toast.error("Failed to Add Data", 3000, "topRight");
      setLoading(false);
    }
  };

  // Set up update modal with selected item data
  const handleUpdate = (id, data) => {
    setUpdateId(id);
    setUpdateModal(true);
    setUpdateData({
      item_name: data.item_name || data.type || "",
      item_name_tamil: data.item_name_tamil || "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  // Update product item
  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        item_name: updateData.item_name,
        item_name_tamil: updateData.item_name_tamil,
        updated_by: "",
        updated_date: "",
      };
      await axios.put(`${ApiUrl}/Api/product_type.php/${updateid}`, formData);
      setUpdateModal(false);
      toast.success("Update Successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to Update the record", 3000, "topRight");
      setLoading(false);
    }
  };

  // Delete product type
  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/product_type.php/${getdeleteid}`);
      setDeleteShowModals(false);
      toast.success("Deleted successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete the record", 3000, "topRight");
      setLoading(false);
    }
  };

  // Pagination handlers
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  // Render pagination buttons
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // First page and ellipsis
    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    // Visible page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    // Last page and ellipsis
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Print Function
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Products Type Report</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h1 { text-align: center; color: #333; margin-bottom: 30px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; font-weight: bold; }
          tr:nth-child(even) { background-color: #f9f9f9; }
          @media print {
            body { margin: 0; }
            table { font-size: 12px; }
          }
        </style>
      </head>
      <body>
        <h1>Products Type Report</h1>
        <p><strong>Total Records:</strong> ${filteredData.length}</p>
        <p><strong>Generated on:</strong> ${new Date().toLocaleString()}</p>
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            ${filteredData
              .map(
                (item, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${item.type || ""}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);

    toast.success("Print dialog opened!", 2000, "topRight");
  };

  // PDF Export Function
  const exportPDF = () => {
    try {
      const doc = new jsPDF();

      // Add title
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.text("Products Type Report", 105, 20, { align: "center" });

      // Add metadata
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Total Records: ${filteredData.length}`, 14, 35);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 42);

      // Prepare table data
      const tableColumn = ["S.No", "Type"];
      const tableRows = filteredData.map((item, index) => [
        index + 1,
        item.type || "",
      ]);

      // Add table
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 50,
        theme: "striped",
        headStyles: {
          fillColor: [66, 139, 202],
          textColor: 255,
          fontStyle: "bold",
        },
        margin: { top: 50, left: 14, right: 14 },
        styles: {
          fontSize: 8,
          cellPadding: 3,
        },
      });

      // Save PDF
      doc.save(
        `products-type-report-${new Date().toISOString().split("T")[0]}.pdf`
      );
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to export PDF", 3000, "topRight");
    }
  };

  // Copy to Clipboard Function
  const copyToClipboard = () => {
    try {
      const headers = "S.No\tType\n";
      const rows = filteredData
        .map((item, index) => `${index + 1}\t${item.type || ""}`)
        .join("\n");

      const clipboardData = headers + rows;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(clipboardData)
          .then(() => {
            toast.success("Data copied to clipboard!", 3000, "topRight");
          })
          .catch(() => {
            fallbackCopyTextToClipboard(clipboardData);
          });
      } else {
        fallbackCopyTextToClipboard(clipboardData);
      }
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  // Fallback copy function
  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      toast.success("Data copied to clipboard!", 3000, "topRight");
    } catch (err) {
      toast.error("Failed to copy data", 3000, "topRight");
    }

    document.body.removeChild(textArea);
  };

  // CSV Export Function
  const exportCSV = () => {
    try {
      const headers = ["S.No", "Type"];
      const csvData = [
        headers,
        ...filteredData.map((item, index) => [index + 1, item.type || ""]),
      ];

      const csvContent = csvData
        .map((row) =>
          row
            .map((field) => {
              if (
                typeof field === "string" &&
                (field.includes(",") ||
                  field.includes('"') ||
                  field.includes("\n"))
              ) {
                return `"${field.replace(/"/g, '""')}"`;
              }
              return field;
            })
            .join(",")
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `products-type-report-${new Date().toISOString().split("T")[0]}.csv`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV exported successfully!", 3000, "topRight");
      }
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Failed to export CSV", 3000, "topRight");
    }
  };

  // Excel Export Function
  const exportExcel = () => {
    try {
      const headers = ["S.No", "Type"];
      const excelData = [
        headers,
        ...filteredData.map((item, index) => [index + 1, item.type || ""]),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      // Set column widths
      const colWidths = [
        { wch: 8 }, // S.No
        { wch: 25 }, // Type
      ];
      worksheet["!cols"] = colWidths;

      // Style the header row
      const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "4F81BD" } },
          alignment: { horizontal: "center" },
        };
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Product Types");

      // Add metadata
      workbook.Props = {
        Title: "Products Type Report",
        Subject: "Product Type Data Export",
        Author: "Product Management System",
        CreatedDate: new Date(),
      };

      XLSX.writeFile(
        workbook,
        `products-type-report-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      toast.success("Excel exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Failed to export Excel", 3000, "topRight");
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-3">
        {/* Add Item Button */}

        <div className="row">
          <div className="col-lg-4">
            <div className="d-flex mb-4">
              <h6 className="card-title m-2">Type</h6>
              <button
                className="btn btn-primary btn-sm rounded-3"
                onClick={openModal}
              >
                Add <span className="ms-2">+</span>
              </button>
            </div>
          </div>
          <div className="col-lg-6"></div>
          <div className="col-lg-2">
            <button
              className="btn btn-primary btn-md rounded-3"
              onClick={() => navigate("/products")}
            >
               <i class="fa-solid fa-arrow-left"> </i> back
              
            </button>
          </div>
        </div>

        {/* Item List Card */}
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              <div className="d-flex mb-2 mb-md-0">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>
              <div className="search-container w-25">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="card tableCard p-2 ">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Item Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>
                            {showAllItems
                              ? index + 1
                              : (currentPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td>{item.item_name || item.type}{item.item_name_tamil ? <span className="text-muted"> / {item.item_name_tamil}</span> : ""}</td>
                          <td>{item.item_name_tamil || "-"}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-light me-1"
                              onClick={() => handleUpdate(item.id, item)}
                            >
                              <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() =>
                                handleOpenModal(item.id, item.item_name || item.type)
                              }
                            >
                              <i className="fa-solid fa-trash text-danger fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {totalItems > 0 && (
                <div className="row">
                  <div className="col-lg-6">
                    <p className="text-muted">
                      Showing{" "}
                      {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1}{" "}
                      to{" "}
                      {showAllItems
                        ? totalItems
                        : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                      of {totalItems} entries
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {!showAllItems && (
                      <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-end">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(1)}
                              aria-label="First"
                            >
                              <span aria-hidden="true">&laquo;&laquo;</span>
                            </button>
                          </li>
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage - 1)}
                              aria-label="Previous"
                            >
                              <span aria-hidden="true">&laquo;</span>
                            </button>
                          </li>

                          {renderPageNumbers()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage + 1)}
                              aria-label="Next"
                            >
                              <span aria-hidden="true">&raquo;</span>
                            </button>
                          </li>
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(totalPages)}
                              aria-label="Last"
                            >
                              <span aria-hidden="true">&raquo;&raquo;</span>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add Item Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="addItemModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary" id="addItemModalLabel">
                Add Item Name
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handlesubmit}>
                <div className="mb-3">
                  <label htmlFor="item_name" className="form-label">
                    Item Name (English)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="item_name"
                    name="item_name"
                    value={addData.item_name}
                    placeholder="Enter item name in English (Tamil auto-generated)"
                    onChange={(e) => {
                      const eng = e.target.value;
                      setAddData({ ...addData, item_name: eng });
                    }}
                    onBlur={async (e) => {
                      const eng = e.target.value.trim();
                      if (eng) {
                        const tamil = await translateToTamil(eng);
                        if (tamil) setAddData(prev => ({ ...prev, item_name_tamil: tamil }));
                      }
                    }}
                    required
                  />
                  {isTranslating && (
                    <small className="text-muted mt-1 d-block">
                      <span className="spinner-border spinner-border-sm me-1" /> Translating...
                    </small>
                  )}
                  {addData.item_name_tamil && !isTranslating && (
                    <small className="text-muted mt-1 d-block">
                      Tamil: {addData.item_name_tamil}
                    </small>
                  )}
                </div>

                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-sm px-4">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Update Item Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{ display: updateModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="updateItemModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateItemModalLabel"
              >
                Update Item Name
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleupdatesubmit}>
                <div className="mb-3">
                  <label htmlFor="updateItemName" className="form-label">
                    Item Name (English)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="updateItemName"
                    name="item_name"
                    placeholder="Enter item name in English (Tamil auto-generated)"
                    value={updateData.item_name}
                    onChange={(e) => {
                      const eng = e.target.value;
                      setUpdateData({ ...updateData, item_name: eng });
                    }}
                    onBlur={async (e) => {
                      const eng = e.target.value.trim();
                      if (eng) {
                        const tamil = await translateToTamil(eng);
                        if (tamil) setUpdateData(prev => ({ ...prev, item_name_tamil: tamil }));
                      }
                    }}
                    required
                  />
                  {isTranslating && (
                    <small className="text-muted mt-1 d-block">
                      <span className="spinner-border spinner-border-sm me-1" /> Translating...
                    </small>
                  )}
                  {updateData.item_name_tamil && !isTranslating && (
                    <small className="text-muted mt-1 d-block">
                      Tamil: {updateData.item_name_tamil}
                    </small>
                  )}
                </div>

                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-sm px-4">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                  }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>

              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary"> ({getdeletename})</span>?
              </h6>

              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal backdrop */}
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default ProductItem;